import { useCanGoBack, useNavigate, useRouter } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '@/lib/auth';

/**
 * Retour de la page d'un rendez-vous. Historique interne à l'app → on revient
 * d'où l'on vient (liste, tableau de bord…). Page ouverte DIRECTEMENT (lien
 * d'invitation partagé, notification push — aucun historique interne) → on
 * tombe sur la liste des rendez-vous du bon rôle plutôt que de rester bloqué
 * ou de quitter l'app. Placé AVANT le titre dans le DOM, sur sa propre ligne
 * (règle mobile-first), zone de tap 44 px.
 */
export function RendezVousBackButton() {
  const { profile } = useAuth();
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const navigate = useNavigate();

  const listRoute =
    profile?.role === 'tutor' || profile?.role === 'admin'
      ? '/tutor/rendez-vous'
      : '/student/rendez-vous';

  function handleBack() {
    if (canGoBack) router.history.back();
    else void navigate({ to: listRoute });
  }

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Retour"
      className="border-ink-200 text-ink-700 hover:bg-ink-50 mb-3 flex h-11 w-11 items-center justify-center rounded-full border bg-white shadow-sm transition-colors active:scale-95"
    >
      <ArrowLeft className="h-5 w-5" />
    </button>
  );
}
